import axios from "axios";
import { Loader2, PlusCircle, PlusCircleIcon } from "lucide-react";
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "src/components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "src/components/ui/dialog";
import { Input } from "src/components/ui/input";
import { useLanguage } from "src/context/LanguageContext";
import { BaseUrlApi, ErrorMessage } from "src/lib/api";
import { SubLessonData } from "../../../../../../lib/languages";
import MultiFileUpload from "../../../../../../components/MultiFileUpload";

export const DialogAnswerHomeWork = ({ item, fetchAnswers }) => {
  const { language } = useLanguage();
  const t = SubLessonData[language] || SubLessonData.en;

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ title: "" });
  const [files, setFiles] = useState([]);

  const handleAddHomeWork = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${BaseUrlApi}/answer-assignments/${item.id}`, {
        ...form,
        files,
      });
      toast(t.toastAnswerAdded, {
        description: t.toastAnswerAddedDescription,
      });
      await fetchAnswers();
      setOpen(false);
    } catch (error) {
      toast("Error", {
        description: ErrorMessage(error),
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onOpenChange={setOpen}
      dir={language === "ar" ? "rtl" : "ltr"}
    >
      <DialogTrigger asChild>
        <Button variant="ghost" size="sm" className="text-primary h-7">
          <PlusCircle className="h-4 w-4 me-1 text-blue-600" />
          {t.answerHomeWork}
        </Button>
      </DialogTrigger>
      <DialogContent
        className="max-w-xl"
        dir={language === "ar" ? "rtl" : "ltr"}
      >
        <DialogHeader className="gap-2">
          <div className="flex items-center gap-2">
            <PlusCircle className="h-5 w-5" />
            <DialogTitle>
              {t.dialogAnswerTitle} "
              {item.title[language] || item.title.en || item.title.ar || "---"}"
            </DialogTitle>
          </div>
        </DialogHeader>

        <MultiFileUpload
          maxFileSize={50}
          maxFiles={item.max_items}
          name="answer-assignment"
          onUploadComplete={(files) => setFiles(files)}
          onUploading={(isUpload) => setLoading(isUpload)}
        />

        <div className="space-y-2">
          <label htmlFor="title" className="text-sm font-medium">
            {t.titleLabel}
          </label>
          <Input
            id="title"
            value={form.title}
            onChange={(e) => setForm({ ...form, title: e.target.value })}
            placeholder={t.placeholderTitleFile}
          />
        </div>

        <DialogFooter className="sm:justify-between gap-2">
          <DialogClose asChild>
            <Button type="button" variant="outline">
              {t.cancel}
            </Button>
          </DialogClose>
          <Button
            type="button"
            onClick={handleAddHomeWork}
            disabled={loading || files.length === 0}
            className="gap-2"
          >
            {loading ? (
              <Loader2 className="h-4 w-4 animate-spin" />
            ) : (
              <PlusCircleIcon className="h-4 w-4" />
            )}
            {t.addAnswer}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DialogAnswerHomeWork;
